import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  onChangeValue: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]),
  type: PropTypes.string,
};

const defaultProps = {
  onChangeValue: () => {},
  data: { summary: '' },
  type: '',
};

const TextArea = styled.textarea`
  resize: none;
  overflow: hidden;
  min-height: 20px;
  max-height: 100px;
  width: 500px;

  :focus {
    border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
    box-shadow: 0 0 2px 0.1rem rgb(33 150 243 / 40%);
    outline: none;
  }
`;

const Textarea = React.forwardRef(({ data, onChangeValue, type }, ref) => {
  const textareaRef = useRef(ref.current);

  const handleKeyDown = (element) => {
    if (element && element.target) {
      const { target } = element;
      target.style.height = 'inherit';
      target.style.height = '5px';
      target.style.height = `${target.scrollHeight}px`;
    }
  };

  const defaultValue = useMemo(() => {
    const value = type === 'summary' ? data.summary : data.description;
    return value;
  }, [type, data]);

  useEffect(() => {
    textareaRef.current.focus();
  }, []);

  const onChange = (value) => {
    const updatedData = {
      id: parseInt(data.id, 10),
      summary: data.summary,
      description: data.description,
    };
    if (type === 'summary') {
      updatedData.summary = value;
    } else if (type === 'description') {
      updatedData.description = value;
    }
    onChangeValue(updatedData);
  };

  return (
    <TextArea
      defaultValue={defaultValue}
      onChange={(e) => {
        onChange(e.target.value);
        handleKeyDown(e);
      }}
      maxLength={255}
      ref={textareaRef}
      onKeyDown={handleKeyDown}
      onFocus={handleKeyDown}
    />
  );
});

Textarea.propTypes = propTypes;
Textarea.defaultProps = defaultProps;
export default Textarea;
